/**
 * Karrier Handler service
 * @author Erik Banhalmi 2017.06.27.
 */
export class CareerHandlerService {
	constructor($http) {
		'ngInject';
		this.$http = $http;
		this.publicRoot = '/public';
		this.privateRoot = '/private';
	}
	getPageInitData() {
		return this.$http.get(`${this.publicRoot}/career`);
	}
}
